module.exports = __webpack_public_path__ + "static/img/qi_2.35972a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qi_2.jpg
// module id = zCrN
// module chunks = 1